import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { PREFIX, STATES } from './options';

var makeActionType = function makeActionType(serviceName, actionName, stateName) {
  return "".concat(PREFIX, "/").concat(serviceName, "/").concat(actionName, "/").concat(stateName);
};

var makeActionTypesForActionName = function makeActionTypesForActionName(serviceName, actionName) {
  return STATES.reduce(function (r, stateName, i) {
    return _objectSpread({}, r, _defineProperty({}, stateName, makeActionType(serviceName, actionName, stateName)));
  }, {});
};

var makeActionTypesForServiceName = function makeActionTypesForServiceName(serviceDeclaration) {
  return serviceDeclaration.actionsDeclarations.reduce(function (r, actionDeclaration, i) {
    return _objectSpread({}, r, _defineProperty({}, actionDeclaration.name, makeActionTypesForActionName(serviceDeclaration.name, actionDeclaration.name)));
  }, {});
};

export default (function (servicesDeclarations) {
  return servicesDeclarations.reduce(function (r, serviceDeclaration, i) {
    return _objectSpread({}, r, _defineProperty({}, serviceDeclaration.name, makeActionTypesForServiceName(serviceDeclaration)));
  }, {});
});